import React from 'react';

import {DocumentActionsButton} from 'app/components/general/DocumentActionsButton';
import {getMediaImageSource} from 'app/documents/utils';
import {useAccountSettingsState} from 'app/settings/api';

import {GenericWidget} from './GenericWidget';

import {DocumentSerializedType} from 'sweet-types';

interface Props {
  object: DocumentSerializedType;
  refetchDocs: () => Promise<unknown>;
}

export function DocumentWidget({object, refetchDocs}: Props) {
  const settings = useAccountSettingsState().data!;

  const src = getMediaImageSource(
    object.document.thumbnail,
    settings.MEDIA_URL_READ,
    'small'
  );

  return (
    <GenericWidget
      name={object.name}
      contentType={object.document_content_type}
      url={object.html_url}
      thumbnail={src}
      actionsButton={
        <DocumentActionsButton
          document={object}
          pageContext="folders"
          refreshData={refetchDocs}
        />
      }
    />
  );
}
